import React from "react";
import clsx from "clsx";
import RoomTypeBuilderErrors from "../RoomTypeBuilderErrors";
import IncidentalDepositPresenter from "../../IncidentalDepositPresenter/IncidentalDepositPresenter";
import AddButtonNew from "../../AddButton/AddButtonNew";

class RoomTypeBuilderIncidentalDeposit extends React.Component {

  constructor(props) {
    super(props)

    this.onAddIncidentalDeposit = this.onAddIncidentalDeposit.bind(this)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'incidental_deposit',
      'tab-pane': true
    }) 

    return ( 
      <div className={tabClasses} id="incidental_deposit">
        <div className="row">
          <div className="col-md-12">
            { this.renderErrors() }
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                  <h3 className="panel-title">
                  {`${I18n.t('incidental_deposit')}*`} <span className="ss-help help" title={I18n.t('incidental_deposit_helper_text')}></span>
                </h3>
                </div>
                {this.renderAddButton()}
              </div>
              <div className="panel-body ht-row">
                {this.renderIncidentalDeposit()}
              </div>           
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderIncidentalDeposit() {
    if (this.props.incidental_deposit) {
      return (
        
        <div>
          <div className="col-remove id-remove">
            <button type="button" className="btn btn-secondary" onClick={() => this.props.onChangeIncidentalDeposit(null)}>{I18n.t('remove')}</button>
          </div>
  
          <IncidentalDepositPresenter 
            incidental_deposit={this.props.incidental_deposit} 
            nested={true} 
            hideModalButtons={true} />
        </div>
      )
    } else {
      return (
        <div className="no-records">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
  }

  renderAddButton() {
    if (!this.props.incidental_deposit) {
      return (
        <div className="col-md-6 content-right flexed">
          <AddButtonNew
            model="IncidentalDeposit" 
            ids={this.props.incidental_deposit ? [this.props.incidental_deposit.id] : null} 
            onAdd={this.onAddIncidentalDeposit}
            new_button={false}
            text= {I18n.t("add")}
            buttonClasses="btn btn-secondary"
            generalPosition="left"
             />
          {/* <AddButton 
            model="IncidentalDeposit" 
            ids={this.props.incidental_deposit ? [this.props.incidental_deposit.id] : null} 
            onAdd={this.onAddIncidentalDeposit}
            new_button={false}
            text= {I18n.t("add")}
            buttonClasses="btn btn-secondary"
             /> */}
        </div>
      )
    }
  }

  renderErrors() {
    var errors = RoomTypeBuilderErrors.incidental_deposit(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  onAddIncidentalDeposit(incidental_deposit) {
    this.props.onChangeIncidentalDeposit(incidental_deposit)
  }

}

export default RoomTypeBuilderIncidentalDeposit